// extracted by mini-css-extract-plugin
module.exports = {"Modal":"Modal_Modal__31OI7","SmallWidth":"Modal_SmallWidth__3P_E4"};